import PremiumLocked from 'components/Items/Lock'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'

const Input = ({ children, isLocked, isLockedMessage, onChange, ...rest }) => {
  const onChangeProp = onChange

  const navigate = useNavigate()

  return (
    <span className={`${isLocked ? 'relative' : ''}`}>
      <input
        onChange={e => {
          if (isLocked) {
            Swal.fire({
              title: 'Cumpără un abonament',
              text: isLockedMessage,
              icon: 'error',
              timer: '4000',
              confirmButtonText: 'Cumpără abonament',
              confirmButtonColor: 'rgba(var(--primary))',
              showCloseButton: true,
              theme: 'dark',
            }).then(result => {
              if (result.isConfirmed) {
                navigate('/abonamente')
              }
            })
          } else {
            onChangeProp(e)
          }
        }}
        {...rest}
      />
      {isLocked ? (
        <PremiumLocked
          message={false}
          lockStyle={{
            position: 'absolute',
            right: -5,
            top: -5,
            width: '10px',
            height: '7px',
            color: 'rgb(244, 196, 48)',
            zIndex: '101',
          }}
        />
      ) : null}
    </span>
  )
}

export default Input
